import { render, staticRenderFns } from "./AutoGamResolutionModal.vue?vue&type=template&id=265e6615"
import script from "./AutoGamResolutionModal.vue?vue&type=script&lang=js"
export * from "./AutoGamResolutionModal.vue?vue&type=script&lang=js"
import style0 from "./AutoGamResolutionModal.vue?vue&type=style&index=0&id=265e6615&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports